// Package Block
import { useState } from "react";
import { Row, Modal, Spin } from "antd";
import "moment-timezone";
import { shallowEqual, useSelector } from "react-redux";
import { getSettingKey } from "../../../../Common/utils";



export default function AiDashboard({ dashboardData, openModal, setOpenModal, loading }) {
    const [downloading, setDownloading] = useState(false);
    console.log("dashboardData", dashboardData?.message);


    const savedFiles = dashboardData?.saved_files || {};

    const downloadFile = async () => {
        if (!savedFiles?.txt_file) return;

        setDownloading(true);
        try {
            const response = await fetch(savedFiles?.txt_file);
            if (!response.ok) throw new Error("Failed to fetch the file");

            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            const filename =
                decodeURIComponent(savedFiles?.txt_file.split("/").pop()?.split("?")[0] || "") ||
                `${savedFiles?.txt_file || "file"}`;

            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();

            URL.revokeObjectURL(blobUrl);
        } catch (e) {
            console.error("Download failed:", e);
            alert("Download failed. Please try again.");
        } finally {
            setDownloading(false);
        }
    };

    return (
        <Spin spinning={loading}>
            <div>

                {/* <AiDynamicStats stats={dashboardData?.sales_analysis?.metrics} /> */}
                {dashboardData?.success == true ? (
                    <>
                     <Row style={{ height: "123vh" }}>
                            <iframe
                                title="Text Preview"
                                src={savedFiles?.interactive_executive_dashboard}
                                style={{ width: "100%", height: "100%", border: "none" }}
                            />
                        </Row>
                         <Row style={{ height: "108vh" }}>
                            <iframe
                                title="Text Preview"
                                src={savedFiles?.interactive_trend_analysis}
                                style={{ width: "100%", height: "100%", border: "none" }}
                            />
                        </Row>
                        <Row style={{ height: "128vh" }}>
                            <iframe
                                title="Text Preview"
                                src={savedFiles?.interactive_category_performance}
                                style={{ width: "100%", height: "100%", border: "none" }}
                            />
                        </Row>
                       
                        <Row style={{ height: "90vh" }}>
                            <iframe
                                title="Text Preview"
                                src={savedFiles?.interactive_product_performance}
                                style={{ width: "100%", height: "100%", border: "none" }}
                            />
                        </Row>
                       
                        {/* <Row style={{ marginTop: "30px", display: "flex", justifyContent: "space-between", padding: "10px" }} gutter={[16, 16]}>
                            <Col span={12} style={{ border: "1px solid #e9e9e9", borderRadius: "5px" }}>
                                <h2 style={{ borderBottom: "1px solid #e9e9e9", padding: "16px" }}>Top 5 Product by Sales Volume</h2>
                                <img
                                    src={dashboardData.saved_files.top_products}
                                    alt="AI Dashboard"
                                    style={{ width: "100%" }}
                                />
                               
                            </Col>
                            <Col span={11} style={{ border: "1px solid #e9e9e9", borderRadius: "5px" }}>
                                <h2 style={{ padding: "16px" }}>Top Customers</h2>
                                <Table
                                    columns={columns}
                                    dataSource={data}
                                    pagination={false} // Disable pagination if needed
                                    bordered
                                    components={components}
                                    style={{ width: '100%' }}
                                />
                            </Col>
                        </Row>

                        <h2 style={{ padding: "16px" }}>Sales Analysis</h2>
                        <Row gutter={[16, 16]}>
                            <Col span={8}>
                                <AIStatsWidget
                                    name="Insight"
                                    data={dashboardData?.sales_analysis?.insight || {}}
                                    className="card-stretch gutter-b"
                                    currency={currencySymbol}
                                />
                            </Col>
                            <Col span={8}>
                                <AIStatsWidget
                                    name="Metrics"
                                    data={dashboardData?.sales_analysis?.metrics || {}}
                                    className="card-stretch gutter-b"
                                    currency={currencySymbol}
                                />
                            </Col>
                            <Col span={8}>
                                <AIStatsWidget
                                    name="Week-over-Week Comparison"
                                    data={dashboardData?.sales_analysis?.wow_comparison || {}}
                                    className="card-stretch gutter-b"
                                    currency={currencySymbol}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <img
                                    src={savedFiles?.dashboard}
                                    alt="AI Dashboard"
                                    style={{ width: "100%" }}
                                />
                            </Col>
                        </Row>
                        <h2 style={{ padding: "16px" }}>Payment Analysis</h2>
                        <Row gutter={[16, 16]}>
                            <Col span={8}>
                                <AIStatsWidget
                                    name="insight"
                                    data={dashboardData?.payments_analysis?.insight || {}}
                                    className="card-stretch gutter-b"
                                    currency={currencySymbol}
                                />
                            </Col>
                            <Col span={8}>
                                <AIStatsWidget
                                    name="Metrics"
                                    data={dashboardData?.payments_analysis?.metrics || {}}
                                    className="card-stretch gutter-b"
                                    currency={currencySymbol}
                                />
                            </Col>
                            <Col span={8}>
                                <AIStatsWidget
                                    name="Payment Breakdown"
                                    data={dashboardData?.payments_analysis?.payment_breakdown || {}}
                                    className="card-stretch gutter-b"
                                    currency={currencySymbol}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <img
                                    src={savedFiles?.trends}
                                    alt="AI Dashboard"
                                    style={{ width: "100%" }}
                                /></Col>
                        </Row> */}
                    </>
                ) : (
                    <div style={{ textAlign: "center" }}>
                        {dashboardData?.message}
                    </div>
                )}
                <Modal
                    title={"Daily Digest Date"}
                    visible={openModal}
                    onCancel={() => setOpenModal(false)}
                    width={1200}
                    style={{ padding: "0px" }}
                    footer={[
                        <button
                            key="download"
                            onClick={downloadFile}
                            disabled={!savedFiles?.txt_file || downloading}
                            style={{
                                backgroundColor: "rgb(234, 30, 81)",
                                color: "#fff",
                                border: "none",
                                padding: "10px 20px",
                                cursor: !savedFiles?.txt_file || downloading ? "not-allowed" : "pointer",
                                borderRadius: "5px",
                                opacity: !savedFiles?.txt_file || downloading ? 0.7 : 1,
                            }}
                        >
                            {downloading ? "Downloading..." : "Download"}
                        </button>,
                    ]}
                >
                    <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        <iframe
                            title="Text Preview"
                            src={savedFiles?.txt_file}
                            style={{ width: "100%", height: "70vh", border: "none" }}
                        />
                    </div>
                </Modal>
            </div>
        </Spin>
    );
}